export const APP_TITLE = "Pathimo";

export const COLOR_PALETTE = [
  "#ef91ad",
  "#8fb8f4",
  "#f0c27b",
  "#8ccfaf",
  "#b6a0f3",
  "#f0a68d",
  "#7fd1cb",
  "#de8d96",
  "#95b4ff",
  "#d8bf77",
];

export const UI_TEXT = {
  solvedTitle: "Yay! That worked ✨",
  shareTemplate: ({ levelNumber, gridSize, colorCount, timeLabel, difficultyLabel }) =>
    `A tiny cozy win: I cleared Pathimo Level ${levelNumber} in ${timeLabel} on a ${gridSize}x${gridSize} board with ${colorCount} colors (${difficultyLabel}).\nPlay at https://www.pathimo.com`,
  shareSuccess: "Your cozy score card is ready to share ✨",
  shareCopied: "Score card copied. Paste it anywhere you like.",
  shareDownloaded: "Score card downloaded. Cute and ready to send.",
  shareDownloadedWithCaption: "Score card downloaded and caption copied too.",
  shareUnavailable: "Sharing is not supported on this device right now.",
  loadError: "Oops! Something tiny went wrong while setting up the board.",
};

export const GAME_MODE_META = {
  standard: {
    label: "Standard",
    description: "Classic Pathimo, soft and clear.",
    audioVariant: "default",
  },
  cow: {
    label: "Cow",
    description: "A playful farm-flavored skin for the same tidy puzzles.",
    audioVariant: "default",
  },
  cat: {
    label: "Cat",
    description: "A cozy paw-print twist with the same clean puzzle feel.",
    audioVariant: "default",
  },
  garden: {
    label: "Garden",
    description: "Let each path bloom.",
    audioVariant: "garden-ready",
  },
};

export function getGameModeMeta(gameMode = "standard") {
  return GAME_MODE_META[gameMode] || GAME_MODE_META.standard;
}

export const GARDEN_FLOWER_VARIANTS = [
  {
    key: "daisy",
    pathColor: "#d4c3aa",
  },
  {
    key: "chrysanthemum",
    pathColor: "#ad652d",
  },
  {
    key: "sunflower",
    pathColor: "#fad06b",
  },
  {
    key: "orchidaceae",
    pathColor: "#c58271",
  },
  {
    key: "freesia",
    pathColor: "#8a9ebe",
  },
  {
    key: "tulipa",
    pathColor: "#bc5443",
  },
  {
    key: "jasmine",
    pathColor: "#cfbfa7",
  },
  {
    key: "lavender",
    pathColor: "#877ea4",
  },
  {
    key: "peonia",
    pathColor: "#d3837f",
  },
];

export function getGardenPairStyle(colorId = 0) {
  return GARDEN_FLOWER_VARIANTS[colorId % GARDEN_FLOWER_VARIANTS.length];
}

export const GARDEN_FLOWER_ASSET_SIZE = {
  width: 2358,
  height: 1792,
};

export const RENDER_CONFIG = {
  boardPadding: 24,
  minBoardPadding: 14,
  panelRadius: 28,
  gridRadius: 22,
  pathThicknessRatio: 0.29,
  gardenPathEndpointInsetRatio: 0.44,
  endpointRadiusRatio: 0.2,
  endpointGlowRatio: 0.34,
  endpointStrokeRatio: 0.055,
  activePathAlpha: 0.82,
  placedPathAlpha: 0.72,
  gridLineAlpha: 0.11,
  gridCellInsetRatio: 0.08,
};

export const TIMER_TICK_MS = 250;
export const FEEDBACK_DURATION_MS = 2200;
export const GENERATOR_RETRY_LIMIT = 36;
export const SOLVER_YIELD_EVERY = 1200;
export const SOLVER_ITERATION_LIMIT = 90000;
export const MIN_SEGMENT_LENGTH = 3;

export const LEVEL_PROGRESSION = [
  {
    from: 1,
    to: 5,
    size: 3,
    colorRange: [3, 3],
  },
  {
    from: 6,
    to: 10,
    size: 4,
    colorRange: [5, 5],
  },
  {
    from: 11,
    to: 15,
    size: 5,
    colorRange: [6, 6],
  },
  {
    from: 16,
    to: 20,
    size: 6,
    colorRange: [7, 7],
  },
  {
    from: 21,
    to: null,
    size: {
      base: 7,
      stepEvery: 8,
      max: 9,
    },
    colorRange: {
      base: 8,
      stepEvery: 8,
      max: 10,
    },
  },
];
